module.exports = __webpack_public_path__ + "img/studio-lepus.1efca61d.gif";